import styled from 'styled-components';

const TodayWrapper = styled.div`
  margin: 0 auto;
  padding: 1em 1em 2.5em;
  max-width: 1600px;
  box-sizing: border-box;
  width: 100%;
`;

const TitleDate = styled.span`
  font-size: 1.5em;
  margin-left: 20px;
  color: ${props => props.theme.color.label};
`;

const DropDownItem = styled.div`
  display: flex;
  .photo-wrapper {
    width: 40px;
    min-width: 40px;
    height: 40px;
    border-radius: 20px;
    margin-right: 10px;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .practitioner {
    width: calc(100% - 40px - 10px);
  }
  p {
    overflow: hidden;
    margin: 0 0 0.3em;
    &.now-wrap {
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &.specialties {
      margin-bottom: 0;
      font-size: 14px;
      color: ${props => props.theme.color.label};
    }
  }
`;

const StatusButton = styled.button`
  border-radius: 4px;
  border: 2px solid
    ${props => (props.disabled ? props.theme.color.disabled : props.theme.color.primary)};
  color: ${props => (props.disabled ? props.theme.color.disabled : props.theme.color.primary)};
  padding: 7px;
  background: transparent;
  font-size: 14px;
  font-weight: 500;
  width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${props => (props.disabled ? '' : 'cursor: pointer')};
`;

const AppointmentsPageHeader = styled.div`
  display: flex;
  box-sizing: border-box;
  margin: 0.5em 0 1.5em;
  align-items: center;
  justify-content: space-between;
  .caption {
    p {
      margin: 0;
      line-height: 80%;
      &.name {
        font-size: 2.25em;
      }
      &.date {
        font-size: 1.1em;
        margin-top: 0.8em;
        margin-left: 0.1em;
        color: ${props => props.theme.color.label};
        white-space: nowrap;
      }
    }
  }
  .filter {
    -webkit-flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    box-sizing: border-box;
    padding-left: 1em;
    max-width: 1000px;
    width: 100%;
    > div {
      width: 31%;
      margin-right: 3.5%;
      &:last-of-type {
        margin-right: 0;
      }
    }
    & > div,
    & > div > div {
      margin-bottom: 0;
    }
  }
`;

const ActionBtn = styled.button`
    border-radius: 4px;
    border: solid 2px ${p => p.redType ? p.theme.color.error : p.theme.color.primary};
    background-color: ${p => p.redType ? p.theme.color.error : p.theme.color.primary};
    transition: all 0.25s ease-out;
    font-size: 1em;
    text-align: center;
    color: white;
    width: 150px;
    height: 40px;
    box-sizing: border-box;
    padding: 0 0.45em;
    margin: 0 0 0 1.125em;
    outline: none;
    &:hover:enabled{
      cursor: pointer;
      opacity: .8;
    }
    &:disabled {
      border-color: ${p => p.theme.color.disabled};
      background-color: ${p => p.theme.color.disabled};
    }
`;

export { ActionBtn, TodayWrapper, TitleDate, DropDownItem, StatusButton, AppointmentsPageHeader };
